export default {"src":"/_next/static/media/Advanced Diagnostic Tools neuro.310a6686.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};